import type { CSSProperties } from "react";

/** Składa nazwy klas, pomija puste wartości: cx("iot-btn", aktywny && "is-active") */
export function cx(...czesci: Array<string | false | null | undefined>): string {
  return czesci.filter(Boolean).join(" ");
}

/** Zmienne CSS w atrybucie style: style={zmienne({ "--iot-postep": "40%" })} */
export function zmienne(wartosci: Record<`--${string}`, string | number>): CSSProperties {
  return wartosci as CSSProperties;
}

/** Procent 0-100 z wartości i zakresu, do pasków postępu i suwaków */
export function procent(wartosc: number, min = 0, max = 100): string {
  if (max <= min) return "0%";
  const p = ((wartosc - min) / (max - min)) * 100;
  return `${Math.min(100, Math.max(0, p))}%`;
}

// Liczby z przecinkiem: `liczba` z ./format (jedno miejsce formatowania w APP).
